import { CommonService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useRepairOrderQuotesStatusQueryKey = 'useRepairOrderQuotesStatusQueryKey';

export type FetchRepairOrderQuotesStatusInput = {
  id?: number;
};

export const useRepairOrderQuotesStatusQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input: FetchRepairOrderQuotesStatusInput,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof CommonService.getCommonRepairOrderQuoteStatus>>,
      QueryError,
      Awaited<ReturnType<typeof CommonService.getCommonRepairOrderQuoteStatus>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [useRepairOrderQuotesStatusQueryKey, ...(queryKey ?? [{ ...input }])],
    () => CommonService.getCommonRepairOrderQuoteStatus(input.id),
    options
  );
